module.exports = __webpack_public_path__ + "static/media/icon-document.fe9c20a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/icon-document.svg
// module id = 204
// module chunks = 0